import {APIv1} from "../../api";

export async function createSavedCompany({companyInn, isMarket, token}) {
    const finalToken = token || JSON.parse(localStorage.getItem('user'))?.token;

    const body = {
        company_inn: companyInn,
    };

    try {
        let url = isMarket ? '/save/company/market/' : '/save/company/'
        const response = await APIv1.post(url, body, {
            headers: {
                Authorization: `Token ${finalToken}`,
                'Content-Type': 'application/json',
            },
        });

        return {
            success: response.status === 200 || response.status === 201,
            message: response.data?.message || "",
        };
    } catch (error) {
        console.error("Error in createSavedCompany:", error);
        return {success: false, message: "Unknown error"};
    }
}